import { Text } from 'frosted-ui';
import { useFirstRun } from '../../contexts/FirstRunContext';
import { formatDollars, monthlyLift } from './lift';

/**
 * Ties the test back to the revenue step: "Aiming at ~$110/mo more on your
 * $2,000/mo". Renders nothing when there's no revenue (a reload, a skip, or
 * $0, where there's no lift to aim at).
 */
export default function RevenueGoalLine() {
  const { revenue } = useFirstRun();
  if (!revenue) return null;
  const lift = formatDollars(monthlyLift(revenue));

  return (
    <Text as="p" size="2" weight="medium" style={{ color: 'var(--iris-11)', margin: 0 }}>
      {`Aiming at ~${lift}/mo more on your ${formatDollars(revenue)}/mo.`}
    </Text>
  );
}
